import { render, staticRenderFns } from "./SidebarBoxBestCoins.vue?vue&type=template&id=670c53de&scoped=true&"
import script from "./SidebarBoxBestCoins.vue?vue&type=script&lang=js&"
export * from "./SidebarBoxBestCoins.vue?vue&type=script&lang=js&"
import style0 from "./SidebarBoxBestCoins.vue?vue&type=style&index=0&id=670c53de&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "670c53de",
  null
  
)

export default component.exports